const middleware = {}

middleware['attribution'] = require('../middleware/attribution.ts')
middleware['attribution'] = middleware['attribution'].default || middleware['attribution']

middleware['auth'] = require('../middleware/auth.js')
middleware['auth'] = middleware['auth'].default || middleware['auth']

middleware['backButton'] = require('../middleware/backButton.js')
middleware['backButton'] = middleware['backButton'].default || middleware['backButton']

middleware['forwarder'] = require('../middleware/forwarder.js')
middleware['forwarder'] = middleware['forwarder'].default || middleware['forwarder']

middleware['gtm'] = require('../middleware/gtm.ts')
middleware['gtm'] = middleware['gtm'].default || middleware['gtm']

middleware['headerCheck'] = require('../middleware/headerCheck.js')
middleware['headerCheck'] = middleware['headerCheck'].default || middleware['headerCheck']

middleware['homepage'] = require('../middleware/homepage.js')
middleware['homepage'] = middleware['homepage'].default || middleware['homepage']

middleware['i18n'] = require('../middleware/i18n.js')
middleware['i18n'] = middleware['i18n'].default || middleware['i18n']

middleware['landing'] = require('../middleware/landing.js')
middleware['landing'] = middleware['landing'].default || middleware['landing']

middleware['modifyHeaders'] = require('../middleware/modifyHeaders.js')
middleware['modifyHeaders'] = middleware['modifyHeaders'].default || middleware['modifyHeaders']

middleware['retargeting'] = require('../middleware/retargeting.ts')
middleware['retargeting'] = middleware['retargeting'].default || middleware['retargeting']

middleware['setWebsiteCategory'] = require('../middleware/setWebsiteCategory.ts')
middleware['setWebsiteCategory'] = middleware['setWebsiteCategory'].default || middleware['setWebsiteCategory']

middleware['signupMen'] = require('../middleware/signupMen.js')
middleware['signupMen'] = middleware['signupMen'].default || middleware['signupMen']

middleware['specialDesign'] = require('../middleware/specialDesign.js')
middleware['specialDesign'] = middleware['specialDesign'].default || middleware['specialDesign']

middleware['tokenLogin'] = require('../middleware/tokenLogin.js')
middleware['tokenLogin'] = middleware['tokenLogin'].default || middleware['tokenLogin']

middleware['womenSignup'] = require('../middleware/womenSignup.js')
middleware['womenSignup'] = middleware['womenSignup'].default || middleware['womenSignup']

export default middleware
